import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Calendar from './Calendar';
import InterventionCalendar from '../components/work-requests/InterventionCalendar';
import { useAuth } from '../contexts/AuthContext';
import { USER_ROLES } from '../models/School';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`planification-tabpanel-${index}`}
      aria-labelledby={`planification-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const PlanificationPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const { userRole } = useAuth();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Planification
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Gérez vos demandes et interventions dans un seul espace
      </Typography>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="onglets de planification"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab 
            icon={<CalendarMonthIcon />} 
            iconPosition="start" 
            label="Calendrier des demandes" 
            id="planification-tab-0"
            aria-controls="planification-tabpanel-0"
          />
          {userRole === USER_ROLES.TECHNICAL_SERVICE && (
            <Tab 
              icon={<EventNoteIcon />} 
              iconPosition="start" 
              label="Planning des interventions" 
              id="planification-tab-1"
              aria-controls="planification-tabpanel-1"
            />
          )}
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Calendar />
        </TabPanel>

        {userRole === USER_ROLES.TECHNICAL_SERVICE && (
          <TabPanel value={tabValue} index={1}>
            <InterventionCalendar />
          </TabPanel>
        )}
      </Paper>
    </Container>
  );
};

export default PlanificationPage;
